import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  useTheme,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../common/form/CustomTypography";
import FormTextField from "../common/form/FormTextField";
import AppButton from "../common/buttons/AppButton";
interface AddNewAmenityModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (name: string) => void;
  loading?: boolean;
}

const AddNewAmenityModal: React.FC<AddNewAmenityModalProps> = ({
  open,
  onClose,
  onSubmit,
  loading = false,
}) => {
  const theme = useTheme();
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const handleClose = () => {
    setName("");
    setError("");
    onClose();
  };

  const handleSubmit = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setError("Amenity name is required");
      return;
    }
    setError("");
    onSubmit(trimmed);
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        transition: {
          timeout: 300,
          sx: {
            backgroundColor:
              theme.palette.customColors?.backdrop || "rgba(0, 0, 0, 0.4)",
            backdropFilter: "blur(4px)",
          },
        },
        paper: {
          sx: {
            borderRadius: "16px",
            overflow: "hidden",
            maxWidth: { xs: "95vw", sm: "400px" },
            margin: { xs: "16px", sm: "24px" },
          },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          pt: 2,
          pb: 1,
        }}
      >
        <CustomTypography variant="heading4">Add New Amenity</CustomTypography>
        <IconButton size="small" onClick={handleClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ pt: 0 }}>
        <FormTextField
          label="Amenity name"
          title="Amenity name"
          required
          value={name}
          onChange={(_id, value) => {
            setName(value ?? "");
            if (error) setError("");
          }}
          error={Boolean(error)}
          errorMessage={error}
          placeholder="Enter amenity name"
          fontSize="13px"
        />
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2, pt: 0 }}>
        <AppButton variant="grayscale" label="Cancel" onClick={handleClose} />
        <AppButton
          variant="primary"
          label={loading ? "Saving..." : "Save"}
          onClick={handleSubmit}
          disabled={loading}
        />
      </DialogActions>
    </Dialog>
  );
};

export default AddNewAmenityModal;
